<template>
    <b-modal title="Notifica Notipay" ref="mdlNotificationNotipay" id="mdlNotificationNotipay" size="lg" @ok="onOk">
        <div class="sa-tab-scroll">
            <div class="sa-flexbox">
                <div class="sa-flexbox-header">
                    <b-row>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Oggetto:</label>
                            <b-input-group class="mb-3">
                                <b-form-input v-model="jsonData.subject" type="search" id="subject" placeholder="Oggetto"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Codice Fiscale:</label>
                            <b-input-group class="mb-3">
                                <b-form-input v-model="jsonData.fiscalCode" id="subject" placeholder="Codice Fiscale" maxlength="16" class="text-uppercase"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Importo:</label>
                            <b-input-group class="mb-3">
                                <b-form-input v-model="jsonData.amount" id="subject" placeholder="Importo" type="number" step="0.5"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Tipo:</label>
                            <b-form-select v-model="jsonData.tipo" :options="tipoOptions" :value="null" value-field="value" text-field="text"></b-form-select>
                        </b-col>
                    </b-row>
                </div>
                <div class="sa-flexbox-body">
                    <label class="sa-label-data">Message:</label>
                    <vue-editor class="sa-qeditor" :editor-toolbar="customToolbar" v-model="jsonData.message" />
                    <!-- <b-row>
					<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">

					</b-col>
				</b-row> -->
                </div>
            </div>
        </div>
        <!--     <template #modal-footer>
            <b-button size="md" class="no-text" variant="outline-danger" @click="onClickUndo">Annulla</b-button>
            <b-button @click="onOk" variant="outline-success">Salva</b-button>
            <b-button @click="onOkConNotifica" variant="outline-purple">Salva e Notifica</b-button>
        </template> -->
    </b-modal>
</template>

<script>
import { VueEditor } from "vue2-editor";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    components: {
        VueEditor,
    },
    data() {
        return {
            customToolbar: [
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],

                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ],
            tipoOptions: [
                { value: "AS", text: "Archivio Sanitario" },
                { value: "IDC", text: "Interventi Di Chirugia" },
                { value: "PS", text: "Pronto Soccorso" },
            ],
            pathResource: "/notificationnotipay",
            jsonData: {},
            id: "",
            perPage: 1000000,
        };
    },
    methods: {
        show() {
            let me = this;
            me.jsonData = {};
            me.$refs.mdlNotificationNotipay.show();
        },
        /*  resultResponseLoadData(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonData.dataOraEsecuzione = new Date().getTime();
            me.jsonData.dataOraProgrammata = new Date().getTime();
            me.$refs.mdlNotificationNotipay.show();
        }, */
        resulErrorLoadData(error) {
            console.log(error);
        },
        onOk(bvModalEvent) {
            let me = this;
            me.saveResource(me.pathResource, me.jsonData, me.resultResponseSave);
            bvModalEvent.preventDefault();
        },
        resultResponseSave() {
            this.$emit("afterSave");
            this.$refs.mdlNotificationNotipay.hide();
        },
    },
};
/*
TOOLBAR STANDARD
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                ["blockquote", "code-block"],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                ["link", "image", "video"],
                ["clean"], // remove formatting button
            ],

*/
</script>

<style scoped>
.sa-qeditor {
    height: 400px;
    display: flex;
    flex-direction: column;
}
::v-deep .ql-container {
    flex-grow: 1;
    min-height: 350px;
}

.sa-flexbox {
    display: flex;
    flex-direction: column;
    min-height: 600px;
}

.sa-flexbox-body {
    flex: 1;
    display: flex;
    flex-direction: column;
}
</style>
